import { generateClient } from "aws-amplify/api";
import { listCameraTrafficVolumns } from "graphql/customQueries";

const client = generateClient();
export const apiListCameraTrafficVolumes = async (cameraId, startDate, endDate) => {
    try {
        let nextToken = null;
        let items = [];
        while (true) {
            const response = await client.graphql({
                query: listCameraTrafficVolumns,
                variables: {
                    cameraId,
                    timestamp: {
                        between: [startDate, endDate]
                    },
                    nextToken
                }
            });
            items = items.concat(response.data?.listCameraTrafficVolumns?.items || []);
            nextToken = response.data?.listCameraTrafficVolumns?.nextToken;
            if (!nextToken) break;
        }
        return {
            success: true,
            data: items
        };
    } catch (error) {

    }
}